import { useQuery } from '@tanstack/react-query'
import { v1OrganizationsApi } from '../api'

export function useOrganizations(
  page = 1, 
  limit = 10, 
  search?: string, 
  sortBy?: string, 
  sortOrder?: string
) {
  return useQuery({
    queryKey: ['v1', 'organizations', page, limit, search, sortBy, sortOrder],
    queryFn: () => v1OrganizationsApi.getOrganizations(page, limit, search, sortBy, sortOrder)
  })
}
